import { css } from '@linaria/atomic';

const componentDivStyle1 = css`
  height: 100%;
  overflow-y: auto;
`;

export const WeavePageWrapStyles = {
  componentDivStyle1,
};
